import { LogicalDeleteDTO } from '../basic/logicalDeleteDTO';
import { TenantDTO } from '../domain/tenant';

export class ClienteDTO extends LogicalDeleteDTO {
    
    id: number;
    tenant: TenantDTO;
    descrizione: string;
}